module.exports = __webpack_public_path__ + "static/media/dak-all-white.94e8799b.svg";